<template>
  <td
    @click="handleClick"
    :class="['k-calendar-td', cellClass]"
    :style="cellStyle"
    :title="title"
    role="gridcell"
  >
    <span class="k-link">
      {{ formattedValue }}
    </span>
  </td>
</template>
<script>
import { CalendarCell } from '@progress/kendo-vue-dateinputs'

export default {
  name: 'CustomCalendarCell',
  props: {
    ...CalendarCell.props,
    title: {
      type: String,
      default: ''
    },
    mark: {
      type: Boolean,
      default: false
    },
    markRecurrent: {
      type: Boolean,
      default: false
    }
  },
  mounted () {
  },
  computed: {
    cellStyle: function () {
      if (this.mark) {
        return { 
          fontWeight: 'bold', 
          color: 'white',
          backgroundColor: 'var(--secondary-DEFAULT)',
        } 
      } 
      if (this.markRecurrent) {
        return { 
          fontWeight: 'bold', 
          color: 'white',
          backgroundColor: 'var(--primary-800)',
          borderRadius: '20px!important',
        } 
      } 
      if (this.isTodayOverride) {
        return {
          color: 'var(--primary-DEFAULT)',
        }
      }
      return {}
    },
    isTodayOverride () {
      const today = new Date()
      return today.getFullYear() === this.$props.value.getFullYear() &&
        today.getMonth() === this.$props.value.getMonth() &&
        today.getDate() === this.$props.value.getDate()
    },
    cellClass: function () {
      return {
        'k-state-selected': this.$props?.isSelected,
        'k-state-focused': this.$props?.isFocused,
      }
    },
  },
  methods: {
    handleClick: function (e) {
      this.$emit('click', this.$props.value, e)
      this.$emit('change', { value: this.value })
    },
  },
}
</script>
